package ui.composables

import androidx.compose.animation.AnimatedContent
import androidx.compose.animation.Crossfade
import androidx.compose.animation.core.Animatable
import androidx.compose.animation.core.FastOutSlowInEasing
import androidx.compose.animation.core.animateFloat
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.animation.core.updateTransition
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.animation.scaleIn
import androidx.compose.animation.scaleOut
import androidx.compose.animation.slideInVertically
import androidx.compose.animation.slideOutVertically
import androidx.compose.animation.togetherWith
import androidx.compose.foundation.Image
import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.offset
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.wrapContentSize
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.rememberUpdatedState
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.clipToBounds
import androidx.compose.ui.draw.rotate
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.ColorFilter
import androidx.compose.ui.graphics.RectangleShape
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.layout.layout
import androidx.compose.ui.text.TextStyle
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import kotlinx.coroutines.delay
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource
import ui.enums.InfoSection
import ui.theme.B612Mono
import ui.theme.ColorScheme
import ui.theme.accent1

/**
 * Top rotating title to indicate current section
 */
@Composable
fun InfoTitle(
    wonderColor: Color,
    infoSection: InfoSection,
    isSticky: Boolean
) {
    val surface = MaterialTheme.colorScheme.surface
    val bgColor = if (isSticky) wonderColor else wonderColor.copy(alpha = 0f)

    val rotation = remember { Animatable(0f) }
    var currentSection by remember { mutableStateOf(infoSection) }

    // 🔥 simpan request terbaru
    val latestSection by rememberUpdatedState(infoSection)

    LaunchedEffect(Unit) {
        while (true) {
            if (latestSection != currentSection) {

                // rotate keluar
                rotation.animateTo(
                    rotation.value + 180f,
                    animationSpec = tween(250)
                )

                currentSection = latestSection

                // rotate masuk
                rotation.animateTo(
                    rotation.value + 180f,
                    animationSpec = tween(250)
                )
            }

            // kecil supaya tidak busy loop
            delay(16)
        }
    }

    Box(
        modifier = Modifier
            .fillMaxWidth()
            .background(bgColor),
        contentAlignment = Alignment.BottomCenter
    ) {

        Box(
            Modifier
                .background(surface)
                .height(42.dp)
                .fillMaxWidth()
        )

        Box(
            Modifier
                .height(120.dp)
                .width(240.dp)
                .background(
                    surface,
                    shape = RoundedCornerShape(
                        topStartPercent = 100,
                        topEndPercent = 100
                    )
                ),
            contentAlignment = Alignment.Center
        ) {

            // 🔥 CLIP hanya setengah atas
            Box(
                modifier = Modifier
                    .size(200.dp)
                    .clip(RectangleShape)
                    .graphicsLayer {
                        clip = true
                    }
                    .offset(y = 50.dp) // 👈 turunkan supaya pas
            ) {
                CircularText(
                    text = stringResource(currentSection.title)
                        .map { it.toString() },
                    radius = 90.dp,
                    textStyle = TextStyle(
                        fontSize = 16.sp,
                        fontFamily = B612Mono,
                        color = accent1
                    ),
                    modifier = Modifier
                        .fillMaxSize()
                        .graphicsLayer {
                            rotationZ = rotation.value
                        }
                )
            }

            Image(
                painter = painterResource(currentSection.imageDrawable),
                contentDescription = null,
                modifier = Modifier
                    .align(Alignment.BottomCenter)
                    .padding(bottom = 20.dp)
                    .size(48.dp),
                colorFilter = ColorFilter.tint(MaterialTheme.colorScheme.primary)
            )
        }
    }
}